export default "__VITE_PUBLIC_ASSET__7a6d90bc__"